import { useCallback, useRef, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';
import type { Track } from '../types/Track';
import { searchMusicVideos } from '../api/youtube';

export const useYoutubeSearch = () => {
  const [results, setResults] = useState<Track[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const cancelRef = useRef<CancelTokenSource | null>(null);

  const search = useCallback(async (term: string) => {
    if (cancelRef.current) {
      cancelRef.current.cancel('New search started');
    }
    cancelRef.current = axios.CancelToken.source();

    try {
      setLoading(true);
      setError(null);
      const tracks = await searchMusicVideos(term);
      setResults(tracks);
    } catch (e: any) {
      if (!axios.isCancel(e)) {
        setError(e?.message || 'Failed to search YouTube');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { results, loading, error, search };
};
